export default __webpack_public_path__ + "static/media/file-audio.5da4dd54.svg";